var _script, _link, _link2, _style, _style2, _style3, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInventory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    className: "mdl-js",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _script || (_script = /*#__PURE__*/React.createElement("script", {
    xmlns: "",
    src: "chrome-extension://cfebbelgaooomekhpgdkpnjkoggokkld/static/js/inpage.js",
    async: "false"
  })), _link || (_link = /*#__PURE__*/React.createElement("link", {
    xmlns: "",
    type: "text/css",
    rel: "stylesheet",
    id: "dark-mode-custom-link"
  })), _link2 || (_link2 = /*#__PURE__*/React.createElement("link", {
    xmlns: "",
    type: "text/css",
    rel: "stylesheet",
    id: "dark-mode-general-link"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    xmlns: "",
    lang: "en",
    type: "text/css",
    id: "dark-mode-custom-style"
  })), _style2 || (_style2 = /*#__PURE__*/React.createElement("style", {
    xmlns: "",
    lang: "en",
    type: "text/css",
    id: "dark-mode-native-style"
  })), _style3 || (_style3 = /*#__PURE__*/React.createElement("style", {
    xmlns: "",
    lang: "en",
    type: "text/css",
    id: "dark-mode-native-sheet"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "inventory_id_1",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "inventory_id_2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#inventory_id_1"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#inventory_id_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.292 9.066a.347.347 0 0 0-.245-.592h-2.7a.347.347 0 0 0 0 .693h2.7c.092 0 .18-.036.245-.101zM2.367 12.038a.347.347 0 0 0 .245.102h2.7a.347.347 0 0 0 0-.693h-2.7a.347.347 0 0 0-.347.346c0 .092.036.18.102.245zM1.535 9.96a.348.348 0 0 0 0 .695h3a.347.347 0 0 0 0-.693V9.96h-3zM.867 10.547a.348.348 0 0 0-.23-.585H.51a.348.348 0 0 0 0 .695h.127a.348.348 0 0 0 .23-.11zM6.732 13.037a.347.347 0 0 0-.245-.101H.653a.347.347 0 0 0 0 .693h5.834a.347.347 0 0 0 .346-.347.347.347 0 0 0-.101-.245z",
    fill: "#3A3831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.533 12.627c.222-.443.134-.47-.053-.8-.373-.66-1.36-1.732-1.7-3.785.364-.972.567-1.77.607-2.395.14-.392-.095-.492-.704-.3-.765.467-1.356.757-1.773.872C10.777 6.085 9.115 5.267 8.5 4c.341-.71.363-1.149.065-1.313-.206-.111-.614.15-1.225.785l-3 3.5-.232.432a.542.542 0 0 0 .044.58c.798 1.061 3.936 5.25 5.73 7.463-5.122.04-7.887.833-5.925 1.098 1.608.225 5.275.167 8.018.149.32.094.647.167.978.216l4.617.042c.603-.03 1.142-.075 1.572-.123a.76.76 0 0 0 .631-.49c.484-1.309-.298-2.672-2.215-3.445-1.066-.427-1.59-.667-2.025-.267z",
    fill: "#3A3831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.178 6.765 1.049 2.189 1.13-.454.291 3.45-1.19-2.146-1.125.541-.155-3.58z",
    fill: "#72F596"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.86b694eb.svg";
export { ForwardRef as ReactComponent };